import { useEffect, useState } from "react";

export const useFetchItemPropertyOverrides = (sku) => {
    const [itemPropertyOverrides, setItemPropertyOverrides] = useState([]);

    useEffect(() => {
        if (!sku) {
            setItemPropertyOverrides([]);
            return;
        }
        const fetchItemPropertyOverrides = async () => {
            try {
                const rsp = await fetch(`api/itemPropertyOverrides/${sku}`);
                if (!rsp.ok) {
                    console.error(`itemPropertyOverrides ${sku} failed: ${rsp.status}`);
                    setItemPropertyOverrides([]);
                    return;
                }
                setItemPropertyOverrides(await rsp.json());
            } catch (e) {
                console.error(`itemPropertyOverrides ${sku}:`, e);
                setItemPropertyOverrides([]);
            }
        };
        fetchItemPropertyOverrides();
    }, [sku]);

    return itemPropertyOverrides;
};

export const PutItemPropertyOverride = async (sku, salesGeographyLevelId, salesGeographyId, inMarketDate, divisionId, regionId, endInMarketDate = null) => {
    const payload = {
        salesGeographyLevelId: salesGeographyLevelId,
        salesGeographyId: salesGeographyId,
        inMarketDate: inMarketDate,
        endInMarketDate: endInMarketDate ?? null,
        divisionId: divisionId ?? null,
        regionId: regionId ?? null
    };

    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    };

    const response = await fetch(`api/itemPropertyOverrides/${sku}`, requestOptions);
    if (response.ok) {
        return { ok: true, error: null };
    }

    // Surface the reason a save was rejected (e.g. a date-bound validation) to the caller. The
    // controller returns the message as plain text (StringOutputFormatter), but tolerate a JSON
    // string or a ProblemDetails body too.
    let error = null;
    try {
        const text = await response.text();
        if (text) {
            try {
                const body = JSON.parse(text);
                error = typeof body === 'string' ? body : (body?.detail || body?.title || text);
            } catch {
                error = text;
            }
        }
    } catch {
        error = null;
    }
    return { ok: false, error };
};

export const DeleteItemPropertyOverride = async (sku, salesGeographyLevelId, salesGeographyId) => {
    const requestOptions = { method: "DELETE" };
    const response = await fetch(`api/itemPropertyOverrides/${sku}/${salesGeographyLevelId}/${salesGeographyId}`, requestOptions);
    return response.ok;
};
